'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function HPPrinterSetupPage() {
  const [searchValue, setSearchValue] = useState('');

  return (
    <main style={{ fontFamily: "'Roboto', sans-serif" }}>
      {/* ===== NAVBAR ===== */}
      <section style={{ backgroundColor: 'rgb(255, 255, 255)', padding: '16px 0' }}>
        <div
          style={{
            maxWidth: '1224px',
            margin: '0 auto',
            padding: '0 54px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: '67px'
          }}>
          
          {/* HP Logo */}
          <Link href="/hpprintersetup" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <Image
              src="/assets/images/image-1778102925137.png"
              alt="HP Logo"
              width={91}
              height={61}
              style={{ objectFit: 'contain' }}
              priority />
            
          </Link>

          {/* Nav Links */}
          <nav style={{ display: 'flex', alignItems: 'center', gap: '38px' }}>
            <Link href="/hpprintersetup" style={{ color: 'rgb(0, 51, 102)', textDecoration: 'none', fontSize: '16px', fontFamily: "'Roboto', sans-serif" }}>DeskJet</Link>
            <Link href="/hpprintersetup" style={{ color: 'rgb(0, 51, 102)', textDecoration: 'none', fontSize: '16px', fontFamily: "'Roboto', sans-serif" }}>LaserJet</Link>
            <Link href="/hpprintersetup" style={{ color: 'rgb(0, 51, 102)', textDecoration: 'none', fontSize: '16px', fontFamily: "'Roboto', sans-serif" }}>Envy</Link>
            <Link href="/hpprintersetup" style={{ color: 'rgb(0, 51, 102)', textDecoration: 'none', fontSize: '16px', fontFamily: "'Roboto', sans-serif" }}>OfficeJet</Link>
            <Link href="/buy" style={{ color: 'rgb(255,255,255)', background: 'rgb(49, 107, 156)', textDecoration: 'none', fontSize: '15px', fontWeight: 700, padding: '8px 20px', borderRadius: '8px', fontFamily: "'Roboto', sans-serif" }}>Buy Printers</Link>
          </nav>
        </div>
      </section>
      {/* ===== HERO BANNER ===== */}
      <section style={{ backgroundColor: 'rgb(49, 107, 156)', padding: '16px 0', minHeight: '477px', position: 'relative' }}>
        <div
          style={{
            maxWidth: '1224px',
            margin: '0 auto',
            padding: '0 54px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            minHeight: '445px',
            position: 'relative'
          }}>
          
          {/* Left Content */}
          <div style={{ flex: '0 0 55%', maxWidth: '55%' }}>
            {/* Heading */}
            <h1
              style={{
                color: 'rgb(255, 255, 255)',
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: 700,
                fontSize: '36px',
                lineHeight: '1.3',
                marginBottom: '28px',
                marginTop: '84px'
              }}>
              
              Set up Your HP printer
            </h1>

            {/* Subtitle */}
            <p
              style={{
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: 400,
                fontSize: '20px',
                lineHeight: '1.3',
                color: 'rgb(255, 255, 255)',
                marginBottom: '32px'
              }}>
              
              Enter your{' '}
              <strong style={{ fontWeight: 700 }}>hp product name and model number</strong>{' '}
              to get the right Hp software and drivers for you
            </p>

            {/* Search Box + Next Button */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '0', marginBottom: '16px' }}>
              {/* Search Input */}
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  background: '#f7f7f7',
                  border: '2px solid #333',
                  borderRadius: '12px',
                  padding: '12px 15px',
                  width: '500px',
                  maxWidth: '100%'
                }}>
                
                <i className="fas fa-search" style={{ fontSize: '18px', marginRight: '10px', color: '#333' }}></i>
                <input
                  type="text"
                  placeholder="Enter Your Printer Model Number"
                  value={searchValue}
                  onChange={(e) => setSearchValue(e?.target?.value)}
                  style={{
                    border: 'none',
                    outline: 'none',
                    fontSize: '16px',
                    width: '100%',
                    background: 'transparent',
                    fontFamily: "'Roboto', sans-serif"
                  }} />
                
              </div>

              {/* Next Button */}
              <Link
                href={`/driver-download-page${searchValue ? `?model=${encodeURIComponent(searchValue)}` : ''}`}
                style={{
                  marginLeft: '12px',
                  backgroundColor: 'rgb(255, 255, 255)',
                  color: 'rgb(26, 26, 26)',
                  border: '2px solid rgb(0, 0, 0)',
                  borderRadius: '12px',
                  padding: '10px 24px',
                  fontSize: '18px',
                  fontWeight: 400,
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '48px',
                  whiteSpace: 'nowrap',
                  fontFamily: "'Roboto', sans-serif",
                  cursor: 'pointer'
                }}>
                
                Next
              </Link>
            </div>
          </div>

          {/* Right - Printer Image */}
          <div
            style={{
              flex: '0 0 40%',
              maxWidth: '40%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
            
            <Image
              src="https://img.rocket.new/generatedImages/rocket_gen_img_180141df0-1764639322748.png"
              alt="HP Printer"
              width={424}
              height={283}
              style={{ objectFit: 'contain', borderRadius: '7px' }} />
            
          </div>
        </div>
      </section>
      {/* ===== INFO SECTION ===== */}
      <section style={{ backgroundColor: 'rgb(255, 255, 255)', padding: '16px 0', minHeight: '432px' }}>
        <div
          style={{
            maxWidth: '1224px',
            margin: '0 auto',
            padding: '0 54px',
            display: 'flex',
            alignItems: 'flex-start',
            gap: '40px',
            paddingTop: '40px',
            paddingBottom: '40px'
          }}>
          
          {/* Text Content */}
          <div style={{ flex: '1' }}>
            <h3
              style={{
                color: 'rgb(26, 26, 26)',
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: 400,
                fontSize: '21px',
                lineHeight: '1.3',
                marginBottom: '24px'
              }}>
              
              Install HP Software and drivers on each mobile or computer you want to print from. Add the printer on the new devices
            </h3>
            <h3
              style={{
                color: 'rgb(26, 26, 26)',
                fontFamily: '"Open Sans", sans-serif',
                fontWeight: 400,
                fontSize: '21px',
                lineHeight: '1.3'
              }}>
              
              Need additional help with setup? Chat with us.
            </h3>
          </div>

          {/* Printer Image */}
          <div style={{ flex: '0 0 auto' }}>
            <Image
              src="https://img.rocket.new/generatedImages/rocket_gen_img_1073dd957-1772057122495.png"
              alt="HP Printer Setup"
              width={318}
              height={320}
              style={{ objectFit: 'contain' }} />
            
          </div>
        </div>
      </section>
      {/* ===== POLICIES SECTION ===== */}
      <section style={{ backgroundColor: 'rgb(226, 231, 240)', padding: '16px 0', minHeight: '275px' }}>
        <div
          style={{
            maxWidth: '1224px',
            margin: '0 auto',
            padding: '24px 103px'
          }}>
          
          <p
            style={{
              color: 'rgb(57, 57, 217)',
              fontFamily: '"Inter", sans-serif',
              fontWeight: 700,
              fontSize: '24px',
              lineHeight: '1.3',
              marginBottom: '8px'
            }}>
            
            <strong>Policies &amp; Compliance</strong>
          </p>
          <p style={{ fontSize: '16px', lineHeight: '1.5', marginBottom: '8px', color: 'rgb(26,26,26)' }}>
            We follow Google Ads and regional compliance policies to ensure responsible service promotion.
          </p>
          <p style={{ color: 'rgb(50, 81, 166)', fontSize: '16px', lineHeight: '1.3', marginBottom: '8px' }}>
            Disclaimers:
          </p>
          <ul style={{ paddingLeft: '20px' }}>
            <li style={{ fontSize: '14px', lineHeight: '1.3', marginBottom: '8px', color: 'rgb(26,26,26)' }}>
              We are not affiliated with or authorized by any printer or router manufacturer Brand.
            </li>
            <li style={{ fontSize: '14px', lineHeight: '1.3', marginBottom: '8px', color: 'rgb(26,26,26)' }}>
              Trademarked brand names are used strictly for descriptive purposes only.
            </li>
            <li style={{ fontSize: '14px', lineHeight: '1.3', marginBottom: '8px', color: 'rgb(26,26,26)' }}>
              Services are third-party technical assistance offerings designed for business environments.
            </li>
          </ul>
        </div>
      </section>
      {/* ===== FOOTER LINKS ===== */}
      <section style={{ backgroundColor: 'rgb(255, 255, 255)', padding: '16px 0', minHeight: '57px' }}>
        <div
          style={{
            maxWidth: '1224px',
            margin: '0 auto',
            padding: '12px 54px',
            display: 'flex',
            alignItems: 'center',
            gap: '32px',
            flexWrap: 'wrap'
          }}>
          
          <span style={{ fontSize: '14px', color: 'rgb(26,26,26)' }}>All Rights Reserved. | © 2026 Printers Guide.</span>
          <Link href="/" style={{ color: 'rgb(57, 57, 217)', textDecoration: 'none', fontSize: '16px' }}>About</Link>
          <Link href="/contact-us" style={{ color: 'rgb(57, 57, 217)', textDecoration: 'none', fontSize: '16px' }}>Contact</Link>
          <Link href="/refund-policy" style={{ color: 'rgb(57, 57, 217)', textDecoration: 'none', fontSize: '16px' }}>Refund Policy</Link>
          <Link href="/privacy-policy" style={{ color: 'rgb(57, 57, 217)', textDecoration: 'none', fontSize: '16px' }}>Privacy Policy</Link>
          <Link href="/terms-and-condition" style={{ color: 'rgb(57, 57, 217)', textDecoration: 'none', fontSize: '16px' }}>Terms &amp; Condition</Link>
        </div>
      </section>
    </main>);

}